import { useEffect, useState } from 'react';
import PageHeader from '../../Components/PageHeader/PageHeader';
import { ApiHit } from '../../Api/ApiHit';
import { deleteAccount, searchAccount } from '../../Constant/Constant';
import { useDispatch, useSelector } from 'react-redux';
import { setAccountList } from '../../Redux/Actions/AccountAction';
import { setPagination } from '../../Redux/Actions/TableAction';
import AppTable from '../../Components/AppTable/AppTable';
import { setApiJson } from '../../Redux/Actions/ApiAction';
import AddAccount from './AddAccount';
import ActionButton from '../../Components/AppButton/ActionButton';
import DeleteActionButton from '../../Components/AppButton/DeleteActionButton';
import { PencilIcon } from 'lucide-react';
import CustomModal from '../../Components/CustomModal/CustumModal';
import toast from 'react-hot-toast';

function BusinessAccount() {
  const dispatch = useDispatch();
  const TableReducer = useSelector((state) => state.TableReducer);
  const AccountReducer = useSelector((state) => state.AccountReducer);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const handleModalClose = () => {
    dispatch(setApiJson({}));
    setSelectedAccount(null);
    setIsEditModalOpen(false);
    getAccounts();
  };

  useEffect(() => {
    getAccounts();
  }, [TableReducer.pagination.page, TableReducer.pagination.limit]);

  const getAccounts = () => {
    const json = {
      page: TableReducer.pagination.page,
      limit: TableReducer.pagination.limit,
      search: {}
    };
    ApiHit(json, searchAccount).then((res) => {
      console.log("res", res);
      if (res?.statusCode === 200) {
        dispatch(setAccountList(res?.data?.docs));
        const paginationData = {
          total: res?.data?.totalDocs || 0,
          page: TableReducer.pagination.page,
          limit: TableReducer.pagination.limit,
        };
        dispatch(setPagination(paginationData));
      }
    }).catch((error) => {
      console.error("Error fetching accounts:", error);
      toast.error("Error fetching accounts. Please try again.");
    });
  };

  const baseIndex = (TableReducer.pagination.page - 1) * TableReducer.pagination.limit;

  const handleEdit = (account) => {
    setSelectedAccount(account);
    dispatch(setApiJson(account));
    setIsEditModalOpen(true);
  }

  const handleDelete = (account) => {
    ApiHit({_id: account?._id}, deleteAccount).then((res) => {
      if (res?.statusCode === 200) {
        toast.success(res?.message || 'Account deleted successfully');
        getAccounts();
      }
      else {
        toast.error(res?.error || 'Failed to delete account')
      }
    }).catch((error) => {
      console.error("Error deleting account:", error);
      toast.error('Failed to delete account');
    });
  }

  const tableHeaders = [
    {
      title: "S.No",
      key: "serialNumber",
      width: "60px",
      align: "center",
      priority: 1,
      render: (_, _row, index) => {
        const serialNumber = baseIndex + index + 1;
        return (
          <div className="text-center">
            <span className="text-sm font-medium text-gray-900">{serialNumber}</span>
          </div>
        );
      }
    },
    {
      title: "Account Name",
      key: "accountName",
      priority: 1,
      render: (value) => (
        <div className="text-sm text-gray-900">
          {value || 'N/A'}
        </div>
      )
    },
    {
      title: "Status",
      key: "status",
      priority: 1,
      align: "center",
      render: (value) => (
        <div className="flex justify-end md:justify-center">
          <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
            value ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
          }`}>
            {value ? 'Active' : 'Inactive'}
          </span>
        </div>
      )
    },
    {
      title: "Created At",
      key: "createdAt",
      priority: 2,
      render: (value) => (
        <div className="text-sm text-gray-900">
          {value ? new Date(value).toLocaleDateString() : 'N/A'}
        </div>
      )
    },
    {
      title: "Updated At",
      key: "updatedAt",
      priority: 2,
      render: (value) => (
        <div className="text-sm text-gray-900">
          {value ? new Date(value).toLocaleDateString() : 'N/A'}
        </div>
      )
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_value, row) => {
        return (
          <div className="flex justify-end md:justify-center space-x-2">
            <ActionButton
              onClick={() => handleEdit(row)}
              tooltip="Edit Account"
              icon={<PencilIcon className='w-4 h-4' />}
            />

            <DeleteActionButton
              onConfirm={() => handleDelete(row)}
              itemName="account"
              tooltip="Delete Account"
            />
          </div>
        );
      }
    }
  ];

  return (
    <div>
      <PageHeader
        title={'Business Account'}
        description={'Create and manage business accounts and related details'}
      />
      <div className="mt-5">
        <AppTable
          TH={tableHeaders}
          TD={AccountReducer.accountList || []}
          emptyMessage="No accounts found"
          hidePagination={false}
          buttonText={"Add Account"}
          modalComap={(onClose) => <AddAccount onClose={onClose} />}
          modalSize={"sm"}
          onModalClose={handleModalClose}
        />
      </div>

      <CustomModal
        isOpen={isEditModalOpen}
        onClose={handleModalClose}
        size="sm"
      >
        <AddAccount
          isEditMode={true}
          accountData={selectedAccount}
          onClose={handleModalClose}
        />
      </CustomModal>
    </div>
  );
}

export default BusinessAccount;
